<template>
  <div class="product-xunbu">
    <my-markdown
      class="product-xunbu_md"
      :content="config.aboutAPP"
    ></my-markdown>
  </div>
</template>

<script>
import MyMarkdown from "@/components/my-markdown.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MyMarkdown,
  },
  computed: {
    ...mapGetters(["config"]),
  },
};
</script>

<style lang="less" scoped>
.product-xunbu {
  padding-bottom: 50px;

  ::v-deep &_md {
    img {
      width: 50%;
      max-width: 375px;
      margin: 10px auto;
    }
  }
}
</style>
